import React, { Component } from 'react'
import Popover from '@mui/material/Popover'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button'
import { FaFileDownload } from 'react-icons/fa'
import { IconButton } from '../../lib/button'

const CSV_COLUMNS = [
  { key: 'name', label: 'Ad' },
  { key: 'lastname', label: 'Soyad' },
  { key: 'mails_text', label: 'Mail' },
  { key: 'paid_program_count', label: 'Program Sayısı' },
  { key: 'have_active_program', label: 'Aktif Program', format: v => v == 1 ? 'VAR' : 'YOK' }
]

export default class UsersCsvExport extends Component {
  constructor (props) {
    super(props)
    this.state = {
      anchorEl: null,
      selectedKeys: CSV_COLUMNS.map(c => c.key)
    }
  }

  open = (e) => {
    this.setState({ anchorEl: e.currentTarget })
  }

  close = () => {
    this.setState({ anchorEl: null })
  }

  toggle = (key) => {
    this.setState(prev => {
      const selected = prev.selectedKeys.includes(key)
        ? prev.selectedKeys.filter(k => k !== key)
        : [...prev.selectedKeys, key]
      return { selectedKeys: selected }
    })
  }

  export = () => {
    const { data } = this.props
    if (!data || data.length === 0) return
    const selected = CSV_COLUMNS.filter(c => this.state.selectedKeys.includes(c.key))
    if (selected.length === 0) return

    const headers = selected.map(c => c.label).join(',')
    const rows = data.map(row => {
      return selected.map(c => {
        const val = c.format ? c.format(row[c.key]) : (row[c.key] ?? '')
        return `"${String(val).replace(/"/g, '""')}"`
      }).join(',')
    })

    const csv = [headers, ...rows].join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = 'kullanicilar.csv'
    link.click()
    URL.revokeObjectURL(url)
    this.close()
  }

  render () {
    const { anchorEl, selectedKeys } = this.state

    return (
      <>
        <IconButton
          icon={<FaFileDownload />}
          onClick={this.open}
        />
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.close}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          <div style={{ padding: 16, minWidth: 200 }}>
            <div style={{ fontWeight: 'bold', marginBottom: 8 }}>CSV Kolonları</div>
            {CSV_COLUMNS.map(col => (
              <div key={col.key}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedKeys.includes(col.key)}
                      onChange={() => this.toggle(col.key)}
                      size="small"
                    />
                  }
                  label={col.label}
                />
              </div>
            ))}
            <Button
              variant="contained"
              size="small"
              fullWidth
              disabled={selectedKeys.length === 0}
              onClick={this.export}
              style={{ marginTop: 8 }}
            >
              Dışa Aktar
            </Button>
          </div>
        </Popover>
      </>
    )
  }
}
